import React from 'react';

import FrameworkIcon from 'components/FrameworkIcon';
import { getFrameworkIcon } from 'utils/getFrameworkIcon';
import { Icon } from './styles';

const ApplicationIcon = ({ website, badgeRatio, ...props }: any) => {
  const framework = website ? getFrameworkIcon(website) : null;

  if (!framework) return <Icon {...props} />;

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexShrink: 0,
        width: props.width,
        height: props.height,
      }}
    >
      <Icon {...props} icon={framework.icon} title={framework.label} />
      <FrameworkIcon
        badge={{ icon: props.icon, label: website.type?.name || props.icon }}
        size={parseFloat(props.width)}
        disable={props.disable}
        ratio={badgeRatio}
      />
    </div>
  );
};

export default ApplicationIcon;
